<template>
  <button
    type="button"
    class="ai-visibility-toggle"
    :class="{ 'ai-visibility-toggle--on': value }"
    role="switch"
    :aria-checked="String(value)"
    :aria-label="ariaLabel"
    :disabled="disabled"
    @click="$emit('input', !value)"
  >
    <span class="ai-visibility-toggle__track">
      <span class="ai-visibility-toggle__thumb"></span>
    </span>
  </button>
</template>

<script>
export default {
  name: 'AiVisibilityToggle',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-toggle {
  display: inline-flex;
  width: 44px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 0;
}

.ai-visibility-toggle:disabled {
  cursor: default;
  opacity: 0.65;
}

.ai-visibility-toggle:focus {
  outline: 2px solid var(--v-lightYellowColor-base);
  outline-offset: 2px;
}

.ai-visibility-toggle__track {
  position: relative;
  width: 36px;
  height: 20px;
  border-radius: 999px;
  background: var(--v-gray12Color-base);
  transition: background 0.18s ease;
}

.ai-visibility-toggle__thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--v-cardBg-base);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);
  transition: transform 0.18s ease;
}

.ai-visibility-toggle--on .ai-visibility-toggle__track {
  background: var(--v-profileAnchorColor-base);
}

.ai-visibility-toggle--on .ai-visibility-toggle__thumb {
  transform: translateX(16px);
}
</style>
